












































import { Vue, Prop, Component } from 'vue-property-decorator';
import { TextValuePair } from '@/models/TextValuePair';

@Component
export default class SingleSelect extends Vue {
    @Prop({ default: () => [] }) options!: TextValuePair[];
    @Prop() label!: string;
    @Prop({ default: false }) formError!: boolean;
    @Prop({ default: 0 }) tabIndex!: number;

    selectedValues: string[] = [];
    expanded: boolean = false;
    focusedIndex: number = -1;

    get selectedText(): string {
        if (this.selectedValues !== undefined && this.selectedValues.length > 0 && this.options.length > 0) {
            let selectedItems: string = '';
            for (const val of this.selectedValues) {
                const findVal = val;
                const foundVal = this.options.find((o: any) => o.value === findVal);
                if (foundVal !== undefined && foundVal.text !== undefined) {
                    selectedItems = foundVal.text + ', ' + selectedItems;
                }
            }
            if (selectedItems !== '') {
                return selectedItems.slice(0, -2);
            } else {
                return this.label;
            }
        } else {
            return this.label;
        }
    }

    existsInArray(arr: string[], val: string): boolean {
        if (arr === undefined) {
            return false;
        }
        return arr.some(arrVal => {
            return val === arrVal;
        });
    }

    unexpand(e: FocusEvent) {
        if (e.relatedTarget == null || !this.$el.contains(e.relatedTarget as Node)) {
            this.expanded = false;
        }

        this.$emit('blur');
    }

    expand() {
        if (this.options.length > 0) {
            this.expanded = !this.expanded;
        }
    }

    toggleExpand() {
        if (this.options.length > 0) {
            this.expanded = !this.expanded;
            if (this.expanded) {
                const currentIdx = this.options.findIndex(o => this.existsInArray(this.selectedValues, o.value));
                this.focusedIndex = currentIdx >= 0 ? currentIdx : 0;
                
                this.$nextTick(() => {
                    const container = this.$refs.inputContainer as HTMLElement;
                    if (container) container.focus();
                });
            } else {
                this.focusedIndex = -1;
            }
        }
    }

    navigateDown() {
        if (!this.expanded) {
            this.toggleExpand();
            return;
        }
        if (this.focusedIndex < this.options.length - 1) {
            this.focusedIndex++;
            this.scrollToFocused();
        }
    }

    navigateUp() {
        if (!this.expanded) return;
        if (this.focusedIndex > 0) {
            this.focusedIndex--;
            this.scrollToFocused();
        }
    }

    selectFocused() {
        if (!this.expanded) {
            this.toggleExpand();
        } else if (this.focusedIndex >= 0) {
            this.selectOption(this.options[this.focusedIndex]);
        }
    }

    private scrollToFocused() {
        this.$nextTick(() => {
            const container = this.$el.querySelector('.single-select__options-list');
            const item = this.$el.querySelector('.is-focused');
            if (container && item) {
                const itemEl = item as HTMLElement;
                const containerEl = container as HTMLElement;
                if (itemEl.offsetTop < containerEl.scrollTop) {
                    containerEl.scrollTop = itemEl.offsetTop;
                } else if (itemEl.offsetTop + itemEl.offsetHeight > containerEl.scrollTop + containerEl.offsetHeight) {
                    containerEl.scrollTop = itemEl.offsetTop + itemEl.offsetHeight - containerEl.offsetHeight;
                }
            }
        });
    }

    selectOption(payload: TextValuePair) {
        if (!this.existsInArray(this.selectedValues, payload.value)) {
            this.selectedValues = [];
            this.selectedValues.push(payload.value);
            this.$emit('input', this.selectedValues);
            this.$emit('clearError');
        }
        this.expanded = false;
        this.focusedIndex = -1;
    }
}
